import React, { useEffect, useState } from 'react';
import UserClasses from '../Admin/users/Users.module.css';
import ProductClasses from '../Admin/products/Products.module.css';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import { Services } from 'Services';
import { useNavigate } from 'react-router-dom';
import CategoryClasses from '../Admin/categories/AddCategory.module.css';
import { Success, Error } from 'Util/Toast';
import { useForm } from 'react-hook-form';
import { FaRegEdit } from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";
import { SkeletonTheme } from 'react-loading-skeleton';
import UsersSkeleton from '../Admin/users/UsersSkeleton';
import { Button, TablePagination } from '@mui/material';
import { CiSquarePlus } from 'react-icons/ci';
import { HiOutlineSearch } from 'react-icons/hi';
import OrderClasses from '../Admin/orders/Orders.module.css';
import { RxCrossCircled } from 'react-icons/rx';
import productPlaceholder from '../../Assets/no-communities1.gif';

// Updated table headers for products
const productTableHeads = ['Rec ID', 'Product ID', 'Product Name', 'Category', 'Description', 'Actions'];

const RecommendedProducts = () => {
    const [recommendedProducts, setRecommendedProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deletingProductId, setDeletingProductId] = useState(null);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const { register, control, handleSubmit, setValue, formState: { errors } } = useForm();
    const navigate = useNavigate();

    useEffect(() => {
        const token = { Authorization: `token ${localStorage.getItem('Token')}` };
        Services.getRecommendedProducts(token)
            .then((response) => {
                if (response.RecommendedProducts && Array.isArray(response.RecommendedProducts)) {
                    setRecommendedProducts(response.RecommendedProducts);
                    setTotalCount(response.RecommendedProducts.length);
                } else if (response.Status === 1 && Array.isArray(response.RecommendedProducts)) {
                    // Alternative response format handling
                    setRecommendedProducts(response.RecommendedProducts);
                    setTotalCount(response.RecommendedProducts.length);
                } else {
                    setRecommendedProducts([]);
                    setTotalCount(0);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching recommended products:', error);
                setLoading(false);
            });
    }, []);

    // useEffect(() => {
    //     if (searchTerm.trim() !== '') {
    //         const token = { Authorization: `token ${localStorage.getItem('Token')}` };
    //         Services.searchProducts(searchTerm, token)
    //             .then((response) => {
    //                 if (response.RecommendedProducts && Array.isArray(response.RecommendedProducts)) {
    //                     setRecommendedProducts(response.RecommendedProducts);
    //                     setTotalCount(response.RecommendedProducts.length);
    //                 } else {
    //                     setRecommendedProducts([]);
    //                     setTotalCount(0);
    //                 }
    //                 setLoading(false);
    //             })
    //             .catch((error) => {
    //                 console.error('Error searching recommended products:', error);
    //                 setLoading(false);
    //             });
    //     }
    // }, [searchTerm]);

    const handleDeleteProduct = (recId) => {
        const token = { Authorization: `token ${localStorage.getItem('Token')}` };
        Services.deleteRecommendedProduct(recId, token)
            .then((response) => {
                if (response.Status === 1) {
                    setRecommendedProducts((prevProducts) =>
                        prevProducts.filter((product) => product.recId !== recId)
                    );
                    setTotalCount(totalCount - 1);
                    Success(response.Message || 'Product successfully removed from recommendations');
                } else {
                    Error(response.Message || 'Failed to remove product from recommendations');
                }
            })
            .catch((error) => {
                console.error('Error deleting recommended product:', error);
                Error('Failed to delete recommended product');
            });
    };

    const handleDeleteProductClick = (recId) => {
        setDeletingProductId(recId);
        setDeleteModalOpen(true);
    };

    const handleDeleteModalClose = () => {
        setDeleteModalOpen(false);
        setDeletingProductId(null);
    };

    const handleConfirmDelete = () => {
        if (deletingProductId) {
            handleDeleteProduct(deletingProductId);
            handleDeleteModalClose();
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const indexOfLastItem = (page + 1) * rowsPerPage;
    const indexOfFirstItem = indexOfLastItem - rowsPerPage;
    const currentItems = recommendedProducts.slice(indexOfFirstItem, indexOfLastItem);

    useEffect(() => {
        if (searchTerm.trim() !== '') {
            const token = { Authorization: `token ${localStorage.getItem('Token')}` };
            Services.searchRecommendedProducts(searchTerm, token)
                .then((response) => {
                    if (response && Array.isArray(response)) {
                        setRecommendedProducts(response);
                        setTotalCount(response.length);
                    } else {
                        setRecommendedProducts([]);
                        setTotalCount(0);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error searching recommended products:', error);
                    setLoading(false);
                });
        }
    }, [searchTerm]);
    

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleEditProductClick = (recId, productId) => {
        navigate(`/edit-recommended-product/${recId}/${productId}`);
    };

    const renderTable = () => {
        if (currentItems.length === 0) {
            return (
                <div className={UserClasses['no-records-container']}>
                    <img height={100} src={productPlaceholder} alt="No Recommended Products" className={UserClasses['no-records-icon']} data-aos="zoom-in" />
                    <p>No Recommended Products Found</p>
                </div>
            );
        }

        return (
            <table className={ProductClasses['category-table']}>
                <thead>
                    <tr className={UserClasses['main-table-heads']}>
                        {productTableHeads.map((head, index) => (
                            <th key={index} className={ProductClasses['products-table-head']}>{head}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((product, index) => (
                        <tr key={product.recId || index} className={index % 2 === 0 ? UserClasses['even-row'] : UserClasses['odd-row']} data-aos="fade-up"
                            data-aos-anchor-placement="top-bottom">
                            <td className={CategoryClasses["table-cell"]}>{product.recId || 'N/A'}</td>
                            <td className={CategoryClasses["table-cell"]}>{product.productId || 'N/A'}</td>
                            <td className={CategoryClasses["table-cell"]}>{product.productName || 'N/A'}</td>
                            <td className={CategoryClasses["table-cell"]}>{product.categoryName || 'N/A'}</td>
                            <td className={CategoryClasses["table-cell"]}>{product.description || 'N/A'}</td>
                            <td>
                                <button
                                    onClick={() => handleDeleteProductClick(product.recId)}
                                    className={`${CategoryClasses['delete-button']} ${CategoryClasses['button']}`}
                                >
                                    <AiFillDelete />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <Layout Active={'RecommendedProducts'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Recommended Products</title>
            </Helmet>
            <div className={UserClasses['main-first-container']}>
                <div className={UserClasses['main-community-head']}>
                    <div className={ProductClasses['main-add-btn']} data-aos="zoom-in">
                        <Button style={{ height: '35px' }} variant="contained" color="primary" onClick={() => navigate('/add-recommended-product')}>
                            Add Recommended Product <CiSquarePlus className="CiSquarePlus" />
                        </Button>
                    </div>
                    {/* <div className={UserClasses['main-data-tab']}>
                        <div className={UserClasses['form-main-search']} data-aos="zoom-in">
                            <form className={UserClasses['form-search']} action=''>
                                <input
                                    style={{ width: '300px' }}
                                    className={UserClasses['form-input-search']}
                                    type='search'
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    placeholder='Search by product name'
                                />
                            </form>
                        </div>
                    </div> */}
                </div>
                <div className={UserClasses['main-data-tab']}>
                    <div className={UserClasses['users-main']}>
                        <h2 className={OrderClasses['header-form']}>
                            Recommended Products <span className={UserClasses['head-count-main']}>({totalCount})</span>
                        </h2>
                        <div>
                            <SkeletonTheme color='#ddd' highlightColor='#eee'>
                                {loading ? (
                                    <UsersSkeleton TableHeader={productTableHeads} />
                                ) : (
                                    <div style={{ overflowY: 'hidden' }}>
                                        {renderTable()}
                                    </div>
                                )}
                            </SkeletonTheme>
                            <div className={UserClasses['table-pagination']}>
                                <div className={UserClasses['current-page']}>
                                    <p>Current Page: {page + 1}</p>
                                </div>
                                <TablePagination
                                    component="div"
                                    count={recommendedProducts.length}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isDeleteModalOpen && (
                <div className={CategoryClasses['edit-modal-overlay']}>
                    <div className={CategoryClasses['edit-modal']} data-aos="zoom-in-down">
                        <div className={CategoryClasses['modal-content']}>
                            <h1><RxCrossCircled /></h1>
                            <h2>Are you sure?</h2>
                            <p>Do you really want to remove this product from recommendations? This process cannot be undone.</p>
                        </div>
                        <div className={CategoryClasses['modal-last-div']}>
                            <button onClick={handleDeleteModalClose} className={CategoryClasses['modal-close-button']}>Close</button>
                            <button onClick={handleConfirmDelete} className={CategoryClasses['modal-save-button']}>Delete</button>
                        </div>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default RecommendedProducts;